import { render, staticRenderFns } from "./AupairDetails.vue?vue&type=template&id=2c59cb02&"
import script from "./AupairDetails.vue?vue&type=script&lang=js&"
export * from "./AupairDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports